<template>
  <v-dialog
    v-model="displayDialog"
    max-width="500"
    content-class="rounded-lg"
    :fullscreen="$vuetify.breakpoint.xs"
  >
    <v-card elevation="0" rounded="lg">
      <div class="serial-dialog-content">
        <div class="serial-dialog-width-wrapper">
          <div class="signup-step-back">
            <v-icon color="#333333" size="22" @click="displayDialog = false">
              mdi-arrow-left
            </v-icon>
          </div>
          <div class="id-card-images">
            <div class="id-card-image">
              <div class="hint-label">
                <b>
                  {{
                    $i18n.t(
                      "signup.identification.fields.serialNumber.hintDialog.newDocument",
                    )
                  }}
                </b>

                <span>
                  ({{
                    $i18n.t(
                      "signup.identification.fields.serialNumber.hintDialog.documentNumber",
                    )
                  }})
                </span>
              </div>
              <v-img
                class="id-card-image"
                :src="require('@/assets/signup/new-id-card.png')"
              />
            </div>

            <div class="id-card-image">
              <div class="hint-label">
                <b>
                  {{
                    $i18n.t(
                      "signup.identification.fields.serialNumber.hintDialog.oldDocument",
                    )
                  }}
                </b>

                <span>
                  ({{
                    $i18n.t(
                      "signup.identification.fields.serialNumber.hintDialog.serialNumber",
                    )
                  }})
                </span>
              </div>
              <v-img
                class="mi-dva-logo"
                :src="require('@/assets/signup/old-id-card.png')"
              />
            </div>
          </div>
        </div>
      </div>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: "SerialNumberHintDialog",

  props: {
    dialog: Boolean,
  },

  computed: {
    displayDialog: {
      get() {
        return this.dialog;
      },

      set(booleanValue) {
        this.$emit("displayDialog", booleanValue);
      },
    },
  },
};
</script>
<style lang="scss" scoped>
.serial-dialog-content {
  height: 100%;
  padding: 40px;
  @media (max-width: 600px) {
    padding: 20px;
  }
}

.serial-dialog-width-wrapper {
  @media (max-width: 600px) {
    margin: 20px;
  }
}

.id-card-images {
  display: flex;
  justify-content: space-between;
  flex-direction: column;
  gap: 40px 0;
}
.id-card-images > :first-child {
  padding-bottom: 40px;
  border-bottom: 1px solid #e2e0e0;
}
.hint-label {
  font-weight: 500;
  font-size: 16px;
  line-height: 160%;
  color: #333333;
  margin-bottom: 10px;
}
</style>
